import { useEffect, useState } from "react"
import { Outlet, useNavigate } from "react-router-dom"
import "./css/Accounting.css"
import { Container } from "@mui/material"

const Accounting = () => {
    const [activeTab, setActiveTab] = useState(0)

    const navigate = useNavigate()

    let path = window.location.pathname

    const tabs = [
        {
            name: "Customers",
            redirect: "/accounting/customers"
        },
        {
            name: "Quotes",
            redirect: "/accounting/quotes"
        },
        {
            name: "Invoices",
            redirect: "/accounting/invoices"
        },
        {
            name: "Expenses",
            redirect: "/accounting/expenses"
        },
        {
            name: "Recurring Invoice",
            redirect: "/accounting/recurring-invoice"
        }
    ]

    // Set active tab when page is refreshed
    useEffect(() => {
        // Check if we have selected active tab using click
        if (path.includes(tabs[activeTab].redirect) === false) {
            // Active tab needs to be set because of page refresh
            const activeLocation = tabs.findIndex(item => path.includes(item.redirect))

            activeLocation !== -1 && setActiveTab(activeLocation)
        }
    }, [path])

    return (
        <div className="_7nsy">
            <Container>
            <div className="sidebar sidebar_menu">
                <ul>
                    {tabs.map((item, index) => {
                        return (
                            <li key={index} className={index === activeTab ? "active" : undefined} onClick={() => {
                                setActiveTab(index)
                                navigate(item.redirect)
                            }}>
                                {item.name}
                            </li>
                        )
                    })}
                </ul>
            </div>
            </Container>
            <div className="main">
                <Outlet />
            </div>
        </div>
    )
}

export default Accounting
